export default __webpack_public_path__ + "static/media/sun-3.62e6e583.svg";